import { resolveEscapeRoomMediaUrl } from "./escapeRoomMediaUrl";
import { MIN_SIZE } from "./escapeRoomEditorCanvasInteraction";

const DEFAULT_IMAGE_MAX_WIDTH = 480;
const DEFAULT_IMAGE_MAX_HEIGHT = 360;

export function loadImageNaturalSize(url) {
	const src = resolveEscapeRoomMediaUrl(url);
	if (!src) return Promise.reject(new Error("empty url"));
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => {
			const width = img.naturalWidth || img.width || 0;
			const height = img.naturalHeight || img.height || 0;
			if (width > 0 && height > 0) resolve({ width, height });
			else reject(new Error("invalid dimensions"));
		};
		img.onerror = () => reject(new Error("load failed"));
		img.src = src;
	});
}

export function fitImageBoxToCanvas(naturalW, naturalH, opts = {}) {
	const maxWidth = opts.maxWidth ?? DEFAULT_IMAGE_MAX_WIDTH;
	const maxHeight = opts.maxHeight ?? DEFAULT_IMAGE_MAX_HEIGHT;
	const minSize = opts.minSize ?? MIN_SIZE;
	if (!naturalW || !naturalH) {
		return { width: Math.max(minSize, maxWidth), height: Math.max(minSize, maxHeight) };
	}
	const ratio = naturalW / naturalH;
	let width = maxWidth;
	let height = width / ratio;
	if (height > maxHeight) {
		height = maxHeight;
		width = height * ratio;
	}
	width = Math.max(minSize, Math.round(width));
	height = Math.max(minSize, Math.round(height));
	return { width, height };
}

export async function resolveImageElementPlacementSize(url, canvasWidth = 960, canvasHeight = 540) {
	try {
		const natural = await loadImageNaturalSize(url);
		return fitImageBoxToCanvas(natural.width, natural.height, {
			maxWidth: Math.min(DEFAULT_IMAGE_MAX_WIDTH, Math.round((Number(canvasWidth) || 960) * 0.55)),
			maxHeight: Math.min(DEFAULT_IMAGE_MAX_HEIGHT, Math.round((Number(canvasHeight) || 540) * 0.65)),
		});
	} catch {
		return null;
	}
}

export async function resolveImageElementSizeKeepingWidth(url, currentWidth) {
	const w = Math.max(MIN_SIZE, Math.round(Number(currentWidth) || MIN_SIZE));
	try {
		const natural = await loadImageNaturalSize(url);
		const height = Math.max(MIN_SIZE, Math.round(w / (natural.width / natural.height)));
		return { width: w, height };
	} catch {
		return null;
	}
}

export function isImageCornerResizeHandle(handle) {
	const h = String(handle || "");
	const hasE = h.includes("e");
	const hasW = h.includes("w");
	const hasS = h.includes("s");
	const hasN = h.includes("n");
	return (hasE || hasW) && (hasN || hasS);
}
